import React from "react";
import { GuideStatus } from "../types/guide";

// Simple style mapping for status → badge appearance
const styles: Record<GuideStatus, React.CSSProperties> = {
    pending: { background: "#FEF3C7", color: "#92400E", border: "1px solid #FDE68A" },
    pending_activation: { background: "#F3E8FF", color: "#7C3AED", border: "1px solid #DDD6FE" },
    consult_required: { background: "#DBEAFE", color: "#1D4ED8", border: "1px solid #BFDBFE" },
    approved: { background: "#ECFDF5", color: "#065F46", border: "1px solid #A7F3D0" },
    active: { background: "#D1FAE5", color: "#047857", border: "1px solid #6EE7B7" },
    not_fit: { background: "#FEE2E2", color: "#991B1B", border: "1px solid #FCA5A5" },
};

export default function GuideStatusBadge({ status }: { status: GuideStatus }) {
    return (
        <span style={{
            ...styles[status],
            fontSize: 12,
            padding: "2px 8px",
            borderRadius: 999,
            display: "inline-block",
            lineHeight: "18px",
            textTransform: "capitalize"
        }}>
            {status.replace("_", " ")}
        </span>
    );
}
